<template>
    <div v-if="period" class="audition-summary">
        <div class="summary-title">
            <span>{{ period.periodName || '当前期次' }}</span>
            <span class="status-tag" :class="statusClass">{{ statusLabel }}</span>
        </div>
        <div class="summary-grid">
            <div>
                <div class="summary-item"><span class="label">期号</span>{{ period.periodNo || '-' }}</div>
                <div class="summary-item" v-if="period.targetIssueNumber"><span class="label">预测下期</span>{{ period.targetIssueNumber }}</div>
                <div class="summary-item"><span class="label">活动时间</span>{{ period.startTime || '-' }} ~ {{ period.endTime || '-' }}</div>
                <div class="summary-item"><span class="label">提交截止</span>{{ period.endTime || '-' }}</div>
            </div>
            <div>
                <div class="summary-item"><span class="label">彩种范围</span>{{ lotteryTypeText }}</div>
                <div class="summary-item"><span class="label">金额区间</span>{{ formatAmount(period.amountMin) }} ~ {{ formatAmount(period.amountMax) }} 元</div>
                <div class="summary-item"><span class="label">提交限额</span>每人 {{ period.submitLimitPerUser || 1 }} 次</div>
            </div>
            <div>
                <div class="summary-item"><span class="label">排名规则</span>按往期累计积分（红球/前区命中计分）</div>
                <div class="summary-item"><span class="label">跟单意向阈值</span>{{ period.followIntentThreshold || 50 }} 人</div>
                <div class="summary-item"><span class="label">剩余时间</span>{{ remainText }}</div>
            </div>
        </div>
    </div>
    <div v-else-if="showEmpty" class="audition-summary">
        <div class="summary-item" style="text-align:center;color:#999;">暂无期次信息</div>
    </div>
</template>

<script>
export default {
    name: 'PeriodSummary',
    props: {
        period: { type: Object, default: null },
        lotteryOptions: { type: Array, default: () => [] },
        showEmpty: { type: Boolean, default: false }
    },
    computed: {
        statusLabel () {
            const map = { 0: '草稿', 1: '进行中', 2: '已截止', 3: '已结算' }
            return map[this.period && this.period.status] || '未知'
        },
        statusClass () {
            const map = { 0: 'draft', 1: 'running', 2: 'closed', 3: 'settled' }
            return map[this.period && this.period.status] || 'draft'
        },
        lotteryTypeText () {
            if (!this.period || !this.period.lotteryTypes || !this.period.lotteryTypes.length) {
                return '双色球、大乐透'
            }
            const types = this.period.lotteryTypes
            if (!this.lotteryOptions.length) {
                return types.join('、')
            }
            return types.map(v => {
                const item = this.lotteryOptions.find(o => o.dictValue === v)
                return item ? item.dictLabel : v
            }).join('、')
        },
        remainText () {
            if (!this.period || this.period.remainSeconds == null) return '-'
            const seconds = this.period.remainSeconds
            if (seconds <= 0) return '已截止'
            const d = Math.floor(seconds / 86400)
            const h = Math.floor((seconds % 86400) / 3600)
            const m = Math.floor((seconds % 3600) / 60)
            if (d > 0) return `${d}天${h}小时`
            if (h > 0) return `${h}小时${m}分钟`
            return `${m}分钟`
        }
    },
    methods: {
        formatAmount (val) {
            return val != null ? Number(val).toLocaleString() : '-'
        }
    }
}
</script>
